import { render, staticRenderFns } from "./url.vue?vue&type=template&id=ebc23288&scoped=true"
import script from "./url.vue?vue&type=script&lang=js"
export * from "./url.vue?vue&type=script&lang=js"
import style0 from "./url.vue?vue&type=style&index=0&id=ebc23288&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebc23288",
  null
  
)

export default component.exports